// extracted by mini-css-extract-plugin
export var Page = "index-module--Page--5kTBu";
export var PageLoad = "index-module--PageLoad--2UV_Y";
export var LoadIcon = "index-module--LoadIcon--2QJds";
export var LoadRotating = "index-module--LoadRotating--3v4-l";
export var spin = "index-module--spin--6hCEQ";